module.exports = __webpack_public_path__ + "static/img/logo.e3b245a2.png";